/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![UserPlatformIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABxElEQVR4nOWVvUoDQRDHT1D8ABFEO8VSERQUa89GCOF2ZiKsM9EiXV5BCx9An8BaK5WAz6BoZ+dXq4JioeK3RSSR3VzimTPmYmLlwcByc/v/zc7+d89x/sWDyP1AnFEkjyaAeBtADzZMXKHcAkn+a/CdydUNAOJMWNwPlK26Acq2pAKA+OFPAQrlvm4AmA2t2CLerB8AetBsaLh6vkkk5vuchtkUZcv03AbyZsPE//QxVSrkBUWyo4gvFcp7IfhKkewC8aLWurtm4Vgs1grEK4D8Vtmi1qbXiHMjtYlr3atI9n8WFusgrXVXzZVHEVckG47jNKXT6RaPkm58Zm6gqGHGALOTrus2hwC2LdUqJ74GgE4APaxILvwD96SID0wA8bO/wjNvJjn0ZUOr91xMLBWKkfUIK10rAYxbIojnlZJRC0A+jQA4/gRY25XumJNKkzzP6/DbGTrd35324Aquiv1E5KnqAMlGWHE2AJBXn7r6EwBAxnxA8P05oOzZMONALuAgWQaSFwCZUAmZBpLcN4AcYjJeBsh5idnxoo4ZB+fWdE7KLH1UsGP4r1a4GG3u8NcAz0v2AAi4qVRbeU5r3W5y5psPIqTaHlnj4kgAAAAASUVORK5CYII=)
 */
export const UserPlatformIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M16 6a4 4 0 1 1-8 0 4 4 0 0 1 8 0ZM2 20.53A9.53 9.53 0 0 1 11.53 11h.94c1.28 0 2.5.25 3.61.7.41.18.36.77-.05.96a7 7 0 0 0-3.65 8.6c.11.36-.13.74-.5.74H6.15a.5.5 0 0 1-.5-.55l.27-2.6c.02-.26-.27-.37-.41-.16-.48.74-1.03 1.8-1.32 2.9a.53.53 0 0 1-.5.41h-.22C2.66 22 2 21.34 2 20.53Z"
        clipRule="evenodd"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M23.66 16.47c.13.57.34 1.69.34 3.23v2.23a1.4 1.4 0 0 1-2.66.63l-.8-1.6a.5.5 0 0 0-.56-.25c-.26.06-.62.12-.98.12s-.72-.06-.98-.12a.5.5 0 0 0-.56.25l-.8 1.6a1.4 1.4 0 0 1-2.66-.63V19.7c0-1.54.2-2.66.34-3.23.31-1.3 1.36-1.55 2.46-1.79.23-.05.46.03.62.18.16.16.35.33.58.32a19.25 19.25 0 0 1 2 0c.23 0 .42-.16.58-.32a.68.68 0 0 1 .62-.18c1.1.24 2.15.5 2.46 1.8Z"
        className={colorClass}
      />
    </svg>
  );
};
